import React from "react";
import { VStack } from "../components/utils";

const GenericTableHeader = ({
  heading,
  subHeading,
  count,
  selectionCount,
  additionalInfo,
  customClassName,
}: {
  heading: string;
  subHeading: string;
  count?: number;
  selectionCount?: number;
  selectionLimit?: number;
  additionalInfo?: React.ReactNode;
  customClassName?: string;
}) => (
  <div
    className={`${customClassName || "flex flex-col px-6 lg:justify-start"}`}
  >
    <p className="text-lg font-medium text-headerColor whitespace-nowrap">
      {heading}
    </p>

    <VStack>
      <div className="items-center ">
        {count !== undefined && (
          <p className="mr-4 text-xs font-medium text-descriptionColor whitespace-nowrap md:mr-2 inline-flex">
            {`${count} ${subHeading}`}
          </p>
        )}
        {additionalInfo && (
          <div className="text-xs font-medium text-descriptionColor whitespace-nowrap md:mr-2 inline-flex">
            {additionalInfo}
          </div>
        )}
        {selectionCount !== undefined && selectionCount > 0 && (
          <p className="text-xs font-medium text-descriptionColor whitespace-nowrap inline-flex">
            {`( ${selectionCount} ${
              selectionCount > 1 ? "items" : "item"
            } selected )`}
          </p>
        )}
      </div>
    </VStack>
  </div>
);
export default GenericTableHeader;
